module.exports = __webpack_public_path__ + "img/check-green.cecf2c79.svg";